import React from 'react';
import {X, Minus} from 'lucide-react';
import {AssistantPanel, useAssistantPanel} from '../../assistant';

const ResizableAssistantPanel: React.FC = () => {
    const {
        currentAssistantKeyOrId,
        isPanelOpen,
        closeAssistant,
        minimizePanel,
        selectedThreadId,
        handleThreadCreated,
        handleThreadSelect,
        handleNewThread,
        canCloseAssistant,
        openAssistant,
        pendingPrompt
    } = useAssistantPanel();

    if (!isPanelOpen || !currentAssistantKeyOrId) {
        return null;
    }

    const panelStyle: React.CSSProperties = {
        backgroundColor: '#f8f9fa',
        padding: '0.75rem',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden'
    };

    const headerStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '0.5rem',
        paddingBottom: '0.35rem',
        borderBottom: '1px solid #ced4da',
        flexShrink: 0
    };

    const buttonStyle: React.CSSProperties = {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '0.25rem',
        marginLeft: '0.5rem'
    };

    return (
        <div style={panelStyle}>
            <div style={headerStyle}>
                <h5
                    className="mb-0"
                    style={{fontSize: '1rem', fontWeight: 500}}
                >
                    Assistant
                </h5>
                <div>
                    <button
                        onClick={minimizePanel}
                        style={buttonStyle}
                        aria-label="Minimize assistant panel"
                        title="Minimize"
                    >
                        <Minus size={18} />
                    </button>
                    {canCloseAssistant && (
                        <button
                            onClick={closeAssistant}
                            style={buttonStyle}
                            aria-label="Close assistant panel"
                            title="Close"
                        >
                            <X size={18} />
                        </button>
                    )}
                </div>
            </div>
            {/* min-width: 0 on both flex items: without it the column keeps its content's
                intrinsic width and the panel clips it instead of the content fitting the panel */}
            <div style={{flex: '1 1 0', minHeight: 0, minWidth: 0, display: 'flex'}}>
                <div className="d-flex flex-column flex-grow-1" style={{minWidth: 0}}>
                    <AssistantPanel
                        assistantKeyOrId={currentAssistantKeyOrId}
                        selectedThreadId={selectedThreadId}
                        onThreadCreated={handleThreadCreated}
                        onThreadSelect={handleThreadSelect}
                        onNewThread={handleNewThread}
                        // Each assistant remembers its own last conversation
                        onSwitchAssistant={openAssistant}
                        pendingPrompt={pendingPrompt}
                    />
                </div>
            </div>
        </div>
    );
};

export default ResizableAssistantPanel;
